<template>
    <div class="step">
        <div class="step-item" v-for="(item) in stepData" :class="{'active': current === item.step, 'past': current > item.step }" :key="item.step">
            <div class="step-info">
                <div class="step-id">{{item.step}}</div>
                <div class="step-name">{{item.value}}</div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        current: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            stepData: [
                { step: 1, value: '设置账号信息'},
                { step: 2, value: '填写账号信息'},
                { step: 3, value: '注册完成'},
            ]
        }
    },
    methods: {
        onChange() {

        }
    },
}
</script>
<style lang="scss" scoped>
.step{
    display: flex;
    align-items: center;
}
.step-item{
    width: 300px;
    height: 40px;
    position: relative;
    background: #ccc;
    margin-right: 20px; 
    padding-left: 20px;

    &.active{
        background: #FF9800;
        .step-id{
            color: #FF9800;
        }
        
        &:after{
            border-top: 20px solid transparent;
            border-bottom: 20px solid transparent;
            border-left: 20px solid #FF9800;
        }
        &:before{
            border-top: 20px solid #FF9800;
            border-bottom: 20px solid #FF9800;
            border-left: 20px solid #fff;
        }
    }
    &.past{
        background: #FFBC5A;
        .step-id{
            color: #FFBC5A;
        }
        &:after{
            border-top: 20px solid transparent;
            border-bottom: 20px solid transparent;
            border-left: 20px solid #FFBC5A;
        }
        &:before{
            border-top: 20px solid #FFBC5A;
            border-bottom: 20px solid #FFBC5A;
            border-left: 20px solid #fff;
        }
    }

    &:after{
        content: '';
        display: block;
        border-top: 20px solid transparent;
        border-bottom: 20px solid transparent;
        border-left: 20px solid #ccc;
        position: absolute;
        right: -20px;
        top: 0;
        z-index: 10;
    }
    &:before{
        content: '';
        display: block;
        border-top: 20px solid #ccc;
        border-bottom: 20px solid #ccc;
        border-left: 20px solid #fff;
        position: absolute;
        left: 0px;
        top: 0;
    }

    &:first-child{
        border-radius: 4px 0 0 4px;
        padding-left: 0;

        &:before{
            display: none;
        }
    }
    &:last-child{
        border-radius: 0 4px 4px 0;
        padding-left: 25px;

        &:after{
            display: none;
        }
    }
}
.step-info{
    display: flex;
    height: 100%;
    align-items: center;
    padding-left: 20px;

    .step-id{
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: #fff;
        font-size: 14px;
        color: #CCCCCC;
        text-align: center;
        line-height: 24px;
        font-weight: 700;
    }
    .step-name{
        padding-left: 8px;
        font-size: 14px;
        color: #FFFFFF;
    }
}
</style>